var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeaderUser = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 6C12.5 5.33696 12.2366 4.70107 11.7678 4.23223C11.2989 3.76339 10.663 3.5 10 3.5C9.33696 3.5 8.70107 3.76339 8.23223 4.23223C7.76339 4.70107 7.5 5.33696 7.5 6C7.5 6.66304 7.76339 7.29893 8.23223 7.76777C8.70107 8.23661 9.33696 8.5 10 8.5C10.663 8.5 11.2989 8.23661 11.7678 7.76777C12.2366 7.29893 12.5 6.66304 12.5 6ZM6 6C6 4.93913 6.42143 3.92172 7.17157 3.17157C7.92172 2.42143 8.93913 2 10 2C11.0609 2 12.0783 2.42143 12.8284 3.17157C13.5786 3.92172 14 4.93913 14 6C14 7.06087 13.5786 8.07828 12.8284 8.82843C12.0783 9.57857 11.0609 10 10 10C8.93913 10 7.92172 9.57857 7.17157 8.82843C6.42143 8.07828 6 7.06087 6 6ZM4.54062 16.5H15.4625C15.1844 14.5219 13.4844 13 11.4312 13H8.575C6.52187 13 4.82188 14.5219 4.54375 16.5H4.54062ZM3 17.0719C3 13.9937 5.49375 11.5 8.57188 11.5H11.4281C14.5063 11.5 17 13.9937 17 17.0719C17 17.5844 16.5844 18 16.0719 18H3.92813C3.41563 18 3 17.5844 3 17.0719Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeaderUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "f078ac9660a80ae794368fc340d68e16.svg";